export const cleanSlugUrl = title => {
    return title
        .toLowerCase() // Convert to lowercase
        .trim() // Remove leading and trailing spaces
        .replace(/[^a-z0-9/]+/g, "-") // Replace non-alphanumeric characters (except /) with hyphens
        .replace(/-+/g, "-") // Replace multiple hyphens with a single hyphen
        .replace(/^-+/, "") // Remove leading hyphens
        .replace(/-+$/, ""); // Remove trailing hyphens
};
